<template>
	<div class="card">
		<el-table :data="tableData" style="width: 100%" height="calc(100vh - 190px)" >
			<el-table-column label="序号" width="60">
				<template slot-scope='scope'>
					{{scope.$index + 1}}
				</template>
			</el-table-column>
			<el-table-column label="创建时间" width="170">
				<template slot-scope='scope'>
					{{setTime(scope.row.bill.createAt)}}
				</template>
			</el-table-column>
<!-- 			<el-table-column prop="address" label="创建用户">
			</el-table-column> -->
			<el-table-column label="张数">
				<template slot-scope='scope'>
					<span>{{scope.row.cardCount}} 张</span>
				</template>
			</el-table-column>
			<el-table-column label="总金额">
				<template slot-scope='scope'>
					<span class="yellow">{{scope.row.bill.realAmount/100}} 元</span>
				</template>
			</el-table-column>
			<el-table-column prop="addr.address" label="收货地址">
				<template slot-scope='scope'>
					<span v-if="scope.row.addr">{{scope.row.addr.address}} </span>
					<span v-else>自提</span>
				</template>
			</el-table-column>
			<el-table-column label="物流状态">
				<template slot-scope='scope'>
					<span>{{status1[scope.row.bill.expressState]}}</span>
				</template>
			</el-table-column>
			<el-table-column label="付款方式">
				<template slot-scope='scope'>
					<span>银行卡</span>
				</template>
			</el-table-column>
			<el-table-column label="付款状态" width="150" align="center">
				<template slot-scope='scope'>
					<span>{{billingState[scope.row.bill.billingState]}}</span>
				</template>
			</el-table-column>
			<el-table-column label="申请状态" width="150" align="center">
				<template slot-scope='scope'>
					<span>{{status2[scope.row.bill.applyState]}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" width='300' align="center">
				<template slot-scope='scope'>
					<router-link v-if="scope.row.bill.expressState >0" class='blue' style='margin-right: 10px;' :to="{path:'/commodity/wl',query:{id:scope.row.bill.expressInfo.expressNo}}">查看物流</router-link>
					<el-button type="text" v-else disabled>查看物流</el-button>
					<el-button v-if="scope.row.bill.applyState === 0" type="text" disabled>退单</el-button>
					<el-button v-else type="text" @click='centerDialogVisible=true;entityId=scope.row.bill.id'>退单 </el-button>
					<!-- <el-button type="text">申请发票</el-button> -->
					<router-link class='blue' style='margin-left: 10px;' :to="{name:'cardOrderDetail',params:{data:scope.row},query:{id:scope.row.bill.id}}">查看详情</router-link>
				</template>
			</el-table-column>
		</el-table>
		<div class="fenye">
			<el-pagination class='pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40]"
			 :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="allpage">
			</el-pagination>
		</div>
		<el-dialog title="退单" :visible.sync="centerDialogVisible" width="500px" center>
			<span>确认退单？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false;">取 消</el-button>
				<el-button type="primary" @click='entityRefund'>确 定</el-button>
			</span>			
		</el-dialog>
	</div>
</template>

<script>
	import { entityList,entityRefund } from '@/axios/api.js'
	import common from '@/assets/common.js'
	export default {
		data() {
			return {
				tableData: [],
				status:['初始','申请','已开'],
				status1:['未发','已发','签收'],
				status2:['申请','已通过','拒绝'],
				billingState:['未结账','已结账',' 挂账-未结账','挂账-已结账','已退单（完全退单）'],
				centerDialogVisible:false,
				entityId:'',
				allpage:0,//数据总数
				eachPage:10,//每页
				indexPage:0,//当前页	
			}
		},
		methods: {
			handleSizeChange(val) { //console.log(`每页 ${val} 条`);
				this.eachPage = val;
				this.getData()
			},
			handleCurrentChange(val) { //console.log(`当前页: ${val}`);
				this.indexPage = (val-1) * this.eachPage;
				console.log(val)
				this.getData()
			},				
			setTime(str) {
				return common.time(str)
			},
			getData(){
				var data={
				    start:this.indexPage,
				    count:this.eachPage,
				}
				entityList(data)
				.then( res => {
				    console.log(res);
					this.tableData=res.data.obj;
					this.allpage=res.data.total;
					this.tableData.forEach(item => {
						if(item.bill.expressInfo){
							item.bill.expressInfo=JSON.parse(item.bill.expressInfo)
						}
					})
					console.log(this.tableData)
				})
				.catch(err => {
				    console.log(err);
				})
			},
			entityRefund(){
				var data={
				    billId:this.entityId
				}
				entityRefund(data)
				.then( res => {
				    console.log(res);
					if(res.data.code == 0){
						this.$message({
							type:'success',
							message:'退单成功'
						})
						this.centerDialogVisible=false;
						this.getData()
					}else if(res.data.code == 105016){
						this.$message.warning('快递已发货')
					}else if(res.data.code == 105017){
						this.$message.warning('发票已申请')
					}else if(res.data.code == 105010){
						this.$message.warning('重复退单')
					}
				})
				.catch(err => {
				    console.log(err);
				})
			}
		},
		mounted() {
			this.getData()
		}
	}
</script>

<style scoped="scoped">
	.card{margin-top: 20px;}
</style>



// WEBPACK FOOTER //
// src/views/card/list.vue